module.exports = __webpack_public_path__ + "img/428.74910904.png";